import React, {useContext} from 'react';
import {View} from 'react-native';

import sy from '~/styles';
import UserContext from '~/components/context/UserContext';
import {Text, Pressable, LessorPersona} from '~/components/controls';
import {useDispatch} from '~/lib/hooks';
import {setShowDrawer} from '~/actions';

import AccountCircleIcon from '~/images/md-icons/account_circle/materialicons/24px.svg';

const DealerHeader = (props) => {
  const dispatch = useDispatch();
  const {me} = useContext(UserContext);

  return (
    <>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
        }}>
        <Pressable onPress={() => dispatch(setShowDrawer(true))}>
          {me?.fleet?.length === 1 ? (
            <LessorPersona lessor={me.fleet[0].company_name} size={36} />
          ) : (
            <AccountCircleIcon fill="#231fda" width={36} height={36} />
          )}
        </Pressable>

        <Text
          style={[
            sy.xxLarge,
            sy['flex-1'],
            {marginLeft: 20},
            props.titleStyle,
          ]}>
          {props.title}
        </Text>
      </View>
    </>
  );
};

export default DealerHeader;
